export default __webpack_public_path__ + "static/media/backgroundLg.9d9a3f6a.webp";